const SamlContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className="saml-container">{children}</div>;
};

export default SamlContainer;
